import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { formatDateTime, mergeParams } from "../../helpers/helpers";
import AppContext from "../../container/context";

const today = new Date();
const primeiroDia = new Date(today.getFullYear(), today.getMonth() - 1, 1)
  .toISOString()
  .split("T")[0];
const diaAtual = today.toISOString().split("T")[0];

export default function Lista({ history, location }) {
  const { notification } = useContext(AppContext);

  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        periodoInicio: primeiroDia,
        periodoFim: diaAtual,
        escolaId: 0,
      },
      location
    )
  );

  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [faturaSelecionada, setFaturaSelecionada] = useState({});

  useEffect(() => {
    carregar();
    carregarComboEscolas();
  }, []);

  const carregar = (filtrosEnviar = filtros) => {
    if (!filtrosEnviar.periodoInicio)
      return notification("warning", "Selecione uma data de início");
    if (!filtrosEnviar.periodoFim)
      return notification("warning", "Selecione uma data de início");

    setFiltros(filtrosEnviar);
    setCarregando(true);
    api.get("faturas/listarGeral", filtrosEnviar).then((res) => {
      res.forEach((r) => {
        r.periodo = (
          <p>
            {r.vencimentoMes}/{r.vencimentoAno}
          </p>
        );

        r.geradaEm = formatDateTime(r.geracao, "D/M/Y h:m");
        r.vencimento = formatDateTime(r.vencimento, "D/M/Y");
        r.link = (
          <a target="_blank" href={r.iuguUrl} rel="noreferrer">
            {r.iuguUrl}
          </a>
        );

        if (r.pagamento) {
          r.situacao = r.pagamentoExterno
            ? "Pagamento registrado (externo)"
            : "Pagamento registrado";
        } else {
          r.situacao = r.cancelamento
            ? `Cancelada (${formatDateTime(r.cancelamento, "D/M/Y h:m")})`
            : `Pagamento não registrado`;
        }
      });
      setLista(res);
      setCarregando(false);
    });
  };

  const carregarComboEscolas = () => {
    api.get("escolas/listar", { ativas: true }).then((escolas) => {
      setComboEscolas(escolas);
    });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      periodoInicio: {
        label: "Início do período",
        type: "date",
        space: 4,
        value: filtros.periodoInicio,
      },
      periodoFim: {
        label: "Fim do período",
        type: "date",
        space: 4,
        value: filtros.periodoFim,
      },
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        space: 4,
        value: filtros.escolaId,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const selecionarFatura = (fatura) => {
    setFaturaSelecionada(fatura);
  };

  const tRegistros = {
    title: "Faturas geradas",
    columns: [
      {
        label: "Escola",
        name: "escolaNomeFantasia",
      },
      {
        label: "Período (referência)",
        name: "periodo",
      },
      {
        label: "Gerada em",
        name: "geradaEm",
      },
      {
        label: "Vencimento",
        name: "vencimento",
      },
      {
        label: "URL Iugu",
        name: "link",
      },
      {
        label: "Situação",
        name: "situacao",
      },
    ],
    actions: [
      {
        title: "Detalhar",
        action: selecionarFatura,
        icon: "zmdi zmdi-zoom-in",
      },
    ],
    array: lista,
  };

  const camposFaturaGerada = () => {
    const campos = {
      escola: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Escola</h4>
            <p>{faturaSelecionada.escolaNomeFantasia}</p>
          </div>
        ),
      },
      periodo: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Período (referência)</h4>
            <p>{faturaSelecionada.periodo}</p>
          </div>
        ),
      },
      geradaEm: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Gerada em</h4>
            <p>{faturaSelecionada.geradaEm}</p>
          </div>
        ),
      },

      vencimento: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Vencimento</h4>
            <p>{faturaSelecionada.vencimento}</p>
          </div>
        ),
      },

      iuguId: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>ID Iugu</h4>
            <p>{faturaSelecionada.iuguId}</p>
          </div>
        ),
      },

      iuguUrl: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>URL Iugu</h4>
            <p>{faturaSelecionada.iuguUrl}</p>
          </div>
        ),
      },

      situacao: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Situação</h4>
            <p>{faturaSelecionada.situacao}</p>
          </div>
        ),
      },

      pagamentoObservacao: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Observação pagamento</h4>
            <p>{faturaSelecionada.pagamentoObservacao}</p>
          </div>
        ),
      },
    };

    return campos;
  };

  const fFaturaGerada = {
    form: camposFaturaGerada(faturaSelecionada),
    title: "Fatura gerada",

    close: {
      label: "Fechar",
      action: () => setFaturaSelecionada({}),
    },
    customActions: [],
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          {faturaSelecionada.id ? (
            <Form formData={fFaturaGerada} />
          ) : (
            <ActionTable structure={tRegistros} />
          )}
        </>
      )}
    </div>
  );
}
